import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
// import { GoogleLogin } from 'react-google-login';
import { GoogleLogin, GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import { gapi } from 'gapi-script';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import LabelInput from 'components/sales/Input/labelInput/labelInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import Regex from 'services/utils/regex/Regex';
import Loader from 'components/sales/Loader/loader';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import './login.css';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';

const SSOLogin = ({ tryGoogleAuthorisedUserLogin,roleId,history,login_data = [] }) => {
  const [userId, setUserId] = useState('');
  const [isError, setIserror] = useState('');
//   const [roleId,setRoleId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  //const userIdRef = useRef(null);

  // useEffect(() => {
  //   userIdRef.current.focus();
  // }, [userIdRef]);

  useEffect(() => {
    // localStorage.clear();
  }, []);

  const handleSubmit = async (evt) => {
    // evt.preventDefault();
    // if (Regex.email.test(userId)) {
    //   setIserror('');
    //   setIsLoading(true);
    //   const res = await generateOtp(userId);
    //   setIsLoading(false);
    //   if (res === true) {
    //     history.push({
    //       pathname: '/login-otp',
    //       state: { otp: otp, email: userId },
    //     });
    //   }
    // } else {
    //   if (userId === '') {
    //     setIserror(localization.mandatoryField);
    //   } else setIserror(localization.loginErrorMg);
    // }
  };

  // const data = {
  //   'google_token': 'eyJhbGciOiJSUzI1NiIsImtpZCI6IjI3NDA1MmEyYjY0NDg3NDU3NjRlNzJjMzU5MDk3MWQ5MGNmYjU4NWEiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJodHRwczovL2FjY291bnRzLmdvb2dsZS5jb20iLCJuYmYiOjE2NzU3NjYxMDksImF1ZCI6IjU2Mjc1NTk2NzQ2Ny05aXZjOXZwNm44YTMzdTByMWRrbmJwNXBhdGJmZXM5OC5hcHBzLmdvb2dsZXVzZXJjb250ZW50LmNvbSIsInN1YiI6IjEwNjc3NTk2Njc5NTcwNzUxNTk0MCIsImhkIjoibXlwYXJrcGx1cy5jb20iLCJlbWFpbCI6Imt1c2hhbC5rdW1hckBteXBhcmtwbHVzLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJhenAiOiI1NjI3NTU5Njc0NjctOWl2Yzl2cDZuOGEzM3UwcjFka25icDVwYXRiZmVzOTguYXBwcy5nb29nbGV1c2VyY29udGVudC5jb20iLCJuYW1lIjoiS3VzaGFsIEt1bWFyIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hL0FFZEZUcDRsbWMzUUk4a0NTWURUWVREMWI0WkxhdHRIN0V6cmh1ZHBRNC0wPXM5Ni1jIiwiZ2l2ZW5fbmFtZSI6Ikt1c2hhbCIsImZhbWlseV9uYW1lIjoiS3VtYXIiLCJpYXQiOjE2NzU3NjY0MDksImV4cCI6MTY3NTc3MDAwOSwianRpIjoiYjg3NjZmZDRhOTJhZmViZmJkMTdlOWVlYTc1NTA3MjI4YmM3OGM1MiJ9.LdVcVs7pvpg7XMNUHegXYzg2-XShNtoGIUY3TxTA4BrYR-e2trMoVaZPIIOHHnbte-EQ2Gh4W18fqkECKVHKBptE5j3BWDTWt1_j0VbBm_Bjtt0D-yc0-JwqQqcHsfCPIITZfMgxQVXjHHODtAz4RTKb_c-pe7UY_5O5h2eIA9G9RNI6TJBUGPNMgJpn6CaqnN4O5KLjiD78g1QjJqFJzjYvOdENA9niPaRTvX-CEhbuen1u-TGcBlGTs479HwpN5oG7xVetluzHndtHkNXXSzvuYPAre6R03GUl7XXYMxexqI2lSnZSSNyEzk2jui2CuM5xvx5TlIZyx56db6vWcg'
  // }

  const handleGoogleAuthorisedUser = async (data) => {
    if(data) {
      setIsLoading(true);
      const response = await tryGoogleAuthorisedUserLogin(data,roleId);
      setIsLoading(false);
      if (response?.status === true) {
        window.scrollTo(0, 0);
        console.log(localStorage.getItem('authenticated'))
        setTimeout(() => {
          console.log('session start');
        }, 1000);
        window.location.href="/dashboard/pm-dashboard";
      }
    }
  }

//   const clientId = '1088736098243-1249os37p8159hrbq7absbfjok307vfh.apps.googleusercontent.com'; // stage
  const clientId = '562755967467-9ivc9vp6n8a33u0r1dknbp5patbfes98.apps.googleusercontent.com';
  // const onSuccess = (codeResponse) => {
  //   console.log('success:', codeResponse);
  //   var data = {
  //     'google_token': codeResponse.credential
  //   }
  //   if(data) {
  //     handleGoogleAuthorisedUser(data); 
  //   }
  // };
  // const onFailure = (err) => {
  //   console.log('failed:', err);
  //   toast.error('Authentication Failed...');
  // };
  useEffect(() => {
    if(gapi.client !== undefined){
    const initClient = () => {
          gapi.client.init({
          clientId: clientId,
          scope: '',
          cookiepolicy: 'single_host_origin',
          flow: 'auth-code',
          ux_mode:'redirect',
          redirect_uri: 'https://fusion.parkplus.io',
        });
     };
     gapi.load('client:auth2', initClient);       
    }
  },[]);

  const handleSuccess = async (codeResponse) => {
    setIsLoading(true);
    console.log(codeResponse);  
    if(codeResponse?.code){
        const response = await tryGoogleAuthorisedUserLogin(codeResponse.code,roleId);
        setIsLoading(false);
        if (response?.status === true) {
            window.scrollTo(0, 0);
            console.log(localStorage.getItem('authenticated'))
            setTimeout(() => {
            console.log('session start');
            }, 1000);
            window.location.href="/dashboard/pm-dashboard";
        }
    }else{
        setIsLoading(false);
    }
    }
    const handleError = errorResponse => console.log(errorResponse)
  const googleLogin = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: handleSuccess,
    onError: handleError,
  });

  return (
    
    
              <>
              <b className="New-form">
                
                <ButtonWithIcon
                    title="Log In"
                    type="button"
                    src={Images?.ArrowRight}
                    onClick={() => googleLogin()}
                    />
              </b>
              {/* <br/> */}
              {/* <GoogleOAuthProvider clientId={clientId}>
              <GoogleLogin
              flow = 'auth-code'
              ux_mode='redirect'
              redirect_uri="https://fusion.parkplus.io"
              onSuccess={handleSuccess}
              onError={handleError}
            />
            </GoogleOAuthProvider> */}
            </>
           
  );
};



export default SSOLogin;